import { clearStoredSession, loadStoredSession, storeSession, type ApiSession } from './api';

export function getStoredSession() {
  return loadStoredSession();
}

export function saveSession(session: ApiSession) {
  storeSession(session);
}

export function clearSession() {
  clearStoredSession();
}
